import BaseChart from './BaseChart';

/**
 * Sankey chart implementation using VChart
 */
class SankeyChart extends BaseChart {
  /**
   * Get chart specification for sankey chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    // Sankey specific fields for links (edges)
    const sourceField = this.options.sourceField || 'source';
    const targetField = this.options.targetField || 'target';
    const valueField = this.options.valueField || 'value';
    
    return {
      type: 'sankey',
      data,
      sourceField,
      targetField,
      valueField,
      
      // Node specific styling
      node: {
        style: {
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.nodeStyle
        },
        state: {
          hover: {
            stroke: '#fff',
            lineWidth: 2
          },
          ...this.options.nodeState
        },
        ...this.options.node
      },
      
      // Link (edge) specific styling
      link: {
        style: {
          opacity: 0.4,
          ...this.options.linkStyle
        },
        state: {
          hover: {
            opacity: 0.7
          },
          ...this.options.linkState
        },
        ...this.options.link
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabels !== false,
        style: {
          fontSize: 12,
          fontWeight: 'normal',
          ...this.options.labelStyle
        },
        formatter: this.options.labelFormatter
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
  
  /**
   * Prepare data for VChart format
   * @returns {Array} Formatted data for VChart
   */
  prepareData() {
    // Sankey expects data in nodes and links format
    if (this.data.nodes && this.data.links) {
      return [
        {
          id: 'sankeyData',
          values: this.data
        }
      ];
    }
    
    // If data is in simpler format, convert it
    const sourceField = this.options.sourceField || 'source';
    const targetField = this.options.targetField || 'target';
    
    // Extract unique nodes from links
    const nodeMap = new Map();
    const links = this.data;
    
    links.forEach(link => {
      if (!nodeMap.has(link[sourceField])) {
        nodeMap.set(link[sourceField], { name: link[sourceField] });
      }
      if (!nodeMap.has(link[targetField])) {
        nodeMap.set(link[targetField], { name: link[targetField] });
      }
    });
    
    const nodes = Array.from(nodeMap.values());
    
    return [
      {
        id: 'sankeyData',
        values: {
          nodes,
          links
        }
      }
    ];
  }
}

export default SankeyChart; 